import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySupplierPreferredCategoriesTranslations = wrapTranslationsSchema({
	name: 'BuyEasySupplierPreferredCategoriesTranslations',
	title: 'Preferred Categories Section Translations',
	sanityId: 'buyeasy-supplierCategories',
	fields: {
		supplierOverview: 'Supplier Overview',
		contracts: 'Contracts',
		preferredSectionTitle: 'Preferred Supplier For',
		tprmInformation: 'TPRM Information',
		relatedSuppliers: 'Related Suppliers',
		categoryCode: 'Category Code',
		categories: 'Categories',
		companyCodes: 'Company Code(s)',
		companyCode: 'Company Code',
		noCategories: 'No categories',
		status: 'Status',
		commentOnSupplierScope: 'Comments on Supplier scope',
		selectCompanyCodes: 'Select one or more Company Codes to see relevant Categories',
		noCompanyCodeSelected:
			'No Company Code or Category selected. To see any results, please select at least one Company Code or Category.',
		supplierNotPreferred:
			'Supplier is not preferred for your Company Code. To see what Company Codes this Supplier is preferred for, click on the Company Code(s) Filter Button.',
		supplierNotPreferredForCompanyCode: 'Supplier is not preferred for any Company Code',
		noRelatedSuppliers: 'There are no related Suppliers.',
		categoryDescriptions: 'More Information on Categories/CP Codes',
		commentOnSupplierScopeTooltip:
			'Provides further detail of the scope of goods or services provided by the supplier.  For questions, contact the Takeda Supplier Owner.',
	},
});
